'use client';

import { cn } from '@insta-club/utilities';
import * as Slider from '@radix-ui/react-slider';

interface CustomSliderProps {
    value?: number;
    defaultValue?: number;
    onChange?: (value: number) => void;
    className?: string;
}

const RangeSlider: React.FC<CustomSliderProps> = ({ value, defaultValue = 0, onChange, className }) => {
    return (
        <Slider.Root
            value={value !== undefined ? [value] : undefined}
            defaultValue={[defaultValue]}
            onValueChange={(val) => onChange?.(val[0])}
            className={cn('relative flex h-6 w-full touch-none items-center select-none', className)}
        >
            <Slider.Track className='bg-primary-100 relative h-1 grow overflow-hidden rounded-full'>
                <Slider.Range className='from-primary-400 to-primary-600 absolute h-full rounded-full bg-gradient-to-r shadow-[0_0_6px_rgba(37,99,235,0.6)] transition-all duration-300' />
            </Slider.Track>

            <Slider.Thumb
                className={cn(
                    'border-primary-300 block h-3 w-3 rounded-full border bg-white',
                    'shadow-md hover:shadow-[0_0_8px_rgba(59,130,246,0.7)]',
                    'transition-all duration-200 ease-out',
                    'hover:bg-primary-50 focus-visible:ring-primary-300/40 focus-visible:ring-4 focus-visible:outline-none'
                )}
            />
        </Slider.Root>
    );
};

export default RangeSlider;

